// src/pages/MarketContextPage.js
import React from 'react';
import TreasuryYields from '../components/TreasuryYields';

const MarketContextPage = () => {
  return (
    <div className="w-full">
      <div className="max-w-7xl mx-auto px-4 py-4 space-y-6">
        <div>
          <h1 className="text-xl font-bold text-gray-800 mb-1">Market Context</h1>
          <p className="text-sm text-gray-500">
            Macro indicators and market-wide data to contextualise company fundamentals.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <TreasuryYields />
        </div>
      </div>
    </div>
  );
};

export default MarketContextPage;
